import { FC } from 'react';
import { SecondaryButtonProps } from './types';

interface OptionButtonLargeProps extends SecondaryButtonProps {
	svgIcon?: string;
}

const OptionButtonLarge: FC<OptionButtonLargeProps> = (props) => {
	return (
		<button
			className={`
				pop-option-btn pop-text-xs
				pop-flex pop-flex-col pop-items-center pop-justify-center
				pop-w-[15%] pop-h-[25%] pop-sm:pop-w-12 pop-sm:pop-h-12
				pop-sm:pop-w-[20%]
				pop-wrap pop-overflow-hidden pop-h-full
				${props.isDisabled
					? 'disabled:pop-bg-popsizeNeutral10 disabled:pop-text-popsizeNeutral20 pop-border-none'
					: `pop-bg-popsizePrimary10 pop-py-2 pop-border-1 pop-border-popsizePrimary20 pop-text-popsizePrimary90 hover:pop-bg-popsizeSecondary20 hover:pop-border-popsizeSecondary90
						${props.className || ''}`
				}
			`}
			onClick={props.onClick}
			disabled={props.isDisabled}
		>
			{props.svgIcon && (
				<div className="pop-flex flex-col pop-items-center pop-justify-center pop-w-full">
					<div
					className="pop-w-icon pop-h-auto"
					dangerouslySetInnerHTML={{ __html: props.svgIcon }}
					/>
				</div>
				)}
			{props.isLoading ? (
				<span className="pop-loading pop-loading-dots pop-loading-md"></span>
			) : (
				<span className="pop-text-center">{props.children}</span>
			)}
		</button>
	);
};

export default OptionButtonLarge;
